import { createContext } from 'react';

// global context for login data
export const GLOBAL_CONTEXT = createContext({});
export const MASTERdATA = createContext({});
export const WALLET = createContext({});

// same-name variables
export const AD = "AD"; // for admins
export const EP = "EP"; // for employees
export const US = "US"; // for clients
export const All = "All";
export const MMB = "MMB";
export const MMB_LIVE = "MMB_LIVE";

// session storage for non-login user
export const WEBSITE_SESSION_STORAGE = 'website';

// cookie session for login user
// specific user/website cookie 
export const USER_COOKIE_NAME = '__ss_us_';
export const USER_COOKIE_THROTTLE_TIME = 24 * 60 * 60; // [1 day] // [15 min] = 15 * 60; [1 day] = 24 * 60 * 60

// login credentials cookie
export const LOGIN_COOKIE_NAME = '__ss_id_';
export const LOGIN_COOKIE_NAME_SPLITBY = '::::';
export const APP_TYPE_COOKIE_NAME = '__ss_ut_';
export const USER_TYPE_COOKIE_NAME = '__ss_ust_';
export const PAGE_COOKIE_NAME = '__ss_pg_';
export const LOGIN_SESSION_NAME = '__ss_it_';
export const LOGIN_THROTTLE_TIME = 24 * 60 * 60; // [1 day] // [15 min] = 15 * 60; [1 day] = 24 * 60 * 60

// number of rows per page for report
export const INVOICE_DETAIL_ROWS_PER_PAGE = 10;
export const CONSIGNMENT_DETAIL_ROWS_PER_PAGE = 10;
export const ACCOUNT_STATEMENT_ROWS_PER_PAGE = 10;

export const Dashboard = "Dashboard";
export const Booking = "Booking";
export const Booking_Detail1 = "Booking Detail1";
export const Booking_Detail2 = "Booking Detail2";
export const Invoice_Detail = "Invoice Detail";
export const Account_Statment = "Account Statement";
export const Tracking = "Tracking";
export const PickUp_Request = "PickUp Request";
export const PickUp_Status = "PickUp Status";
export const DASHBOARD1 = "DASHBOARD1";
export const DOMESTIC_BOOKING = "DOMESTIC_BOOKING";
export const BOOKING_DETAIL1 = "BOOKING_DETAIL1";
export const BOOKING_DETAIL2 = "BOOKING_DETAIL2";
export const INVOICE_DETAIL = "INVOICE_DETAIL";
export const ACCOUNT_STATEMENT = "ACCOUNT_STATEMENT";
export const TRACKING = "TRACKING";
export const PICKUP_REQUEST = "PICKUP_REQUEST";
export const PICKUP_STATUS = "PICKUP_STATUS";
export const Stock_Incoming = "Stock_Incoming";
export const CREDIT_BOOKING = "Credit_Booking";
export const Transaction = "Transaction";
export const FAST_BOOKING = "FAST_BOOKING";
export const RAZORPAY_TEST = "RazorPay";

// api path 
export const API_PATH = "/MMBCreditClientAPI";

// login path
export const LOGIN_PATH = "/MMBLiveWeb/masterlogin/login/";

// pickup request path for cash
export const CASH_PICKUP_REQUEST_PATH = "/MMBLiveWeb/cashpickuprequest/pickuprequest/";
export const CASH_BOOK_PICKUP_REQUEST_PATH = "/MMBLiveWeb/cashbookpickuprequest/bookingrequest/";
export const CASH_BOOK_PICKUP_REQUEST_PAYMENT_PATH = "/MMBLiveWeb/razorpaypaymentapi/razorpaypayment/";
// pickup request path for credit
export const CREDIT_PICKUP_REQUEST_PATH = "/MMBLiveWeb/creditpickuprequest/pickuprequest/";
export const CREDIT_BOOK_PICKUP_REQUEST_PATH = "/MMBLiveWeb/creditbookpickuprequest/bookingrequest/";
export const CREDIT_BOOK_PICKUP_STATUS_PATH = "/MMBLiveWeb/creditbookpickuprequest/pickupstatus/";
export const BOOKING_REQUEST_PATH = "/MMBLiveWeb/booking/booking/";

// stock incoming path
export const STOCK_INCOMING = "/MMBLiveWeb/incomingstock/incoming/";

// report path 
export const ACCOUNT_STATEMENT_REPORT = "/MMBLiveWeb/report/accountstatement/";
export const INVOICE_REPORT = "/MMBLiveWeb/report/invoice/";
export const CONSIGNMENT_REPORT = "/MMBLiveWeb/report/consignment/";
export const TRACKING_REPORT = "/MMBLiveWeb/report/tracking/";

// booking fast booking
export const FAST_BOOKING_REQUEST_PATH = "/MMBLiveWeb/fastbooking/bookingrequest/"
export const FAST_BOOKING_DOCKETJASPER = "/MMBLiveWeb/fastbooking/printdocket/"
export const WEIGTH_DIMENSION = "/MMBLiveWeb/weigth/dimension/"
export const EWAY_BILL = "/MMBLiveWeb/booking/ewaybill/"

export const COMMON_LOADSHIPPERDETAIL = "/MMBLiveWeb/common/loadsender/";
export const MASTER_CLIENTRATEFORCOURIER = "/MMBLiveWeb/master/clientrateforcourier/"
export const COMMON_LOADRECIEVERDETAIL = "/MMBLiveWeb/common/loadreciever/"
export const MASTER_CLIENT = "/MMBLiveWeb/master/clientmaster/";
export const MASTER_TAXSERIES = "/MMBLiveWeb/master/taxSeries/";
export const MASTER_BRANCH = "/MMBLiveWeb/master/branch/";
export const MASTER_CLIENTADDRESS = "/MMBLiveWeb/master/clientaddress/";
export const MASTER_Company = "/MMBLiveWeb/master/company/";
export const MASTER_CLIENT_VAS = "/MMBLiveWeb/master/clientvasmaster/";
export const MASTER_TATDYS = "/MMBLiveWeb/master/tatdays/";
export const MASTER_CLIENTSERIESRATE = "/MMBLiveWeb/master/clientseriesrate/";
export const MASTER_IMPORT_RATE = "/MMBLiveWeb/master/importrate/";
export const MASTER_IMPORT_RATE_FOR_LOGISTIC = "/MMBLiveWeb/master/importratelogistics/";
export const MASTER_NETWORK = "/MMBLiveWeb/master/network/";
export const MASTER_SERVICE = "/MMBLiveWeb/master/servicemaster/";
export const MASTER_SERVICEASSOCIATE = "/MMBLiveWeb/master/service-associate/";
export const MASTER_CITY = "/MMBLiveWeb/master/city/";
export const MASTER_AREA = "/MMBLiveWeb/master/area/";
export const MASTER_Country = "/MMBLiveWeb/master/country/";
export const MASTER_STATE = "/MMBLiveWeb/master/state/";
export const RAZORPAY = "/MMBLiveWeb/razorpaypayment/razorpay/";

// dashboard path
export const DASHBOARD_REPORT = "/MMBLiveWeb/dashboard/dashboard/";

// alpha numeric regex
export const RGX_ALPHA_NUMERIC = /^[A-Za-z0-9]+$/;  // regex for alpha-numeric

export const PAGE_LOADING_TIME = 500;